import { createContext } from 'react';
import { ISysAdminRead } from 'constants/types';

const UserContext = createContext<{
  user: ISysAdminRead | null;
  setUser: (data: ISysAdminRead | null) => void;
}>({ user: null, setUser: () => null });

export default UserContext;
